// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1NQ9Z","col":"styles_col__2FhA9"};